import { Action } from '@ngrx/store';

// TODO: MODIFY AFTER A NEW QUESTIONNAIRE MUST BE ADDED

export enum DoctorActionTypes {
  GET_PATIENTS = '[Doctor] Get patients',
  GET_PATIENTS_SUCCESS = '[Doctor] Get patients Success',
  GET_PATIENTS_FAILURE = '[Doctor] Get patients Failure',
  GET_GLOBAL_PATIENTS = '[Doctor] Get patients',
  GET_GLOBAL_PATIENTS_SUCCESS = '[Doctor] Get patients Success',
  GET_GLOBAL_PATIENTS_FAILURE = '[Doctor] Get patients Failure',
  GET_QUESTIONNAIRES_C_SCCAI = '[Doctor] Get questionnaires Clinical SCCAI for Patient',
  GET_QUESTIONNAIRES_C_SCCAI_SUCCESS = '[Doctor] Get questionnaires Clinical SCCAI for Patient Success',
  GET_QUESTIONNAIRES_C_SCCAI_FAILURE = '[Doctor] Get questionnaires Clinical SCCAI for Patient Failure',
  GET_QUESTIONNAIRES_C_HBI = '[Doctor] Get questionnaires Clinical HBI for Patient',
  GET_QUESTIONNAIRES_C_HBI_SUCCESS = '[Doctor] Get questionnaires Clinical HBI for Patient Success',
  GET_QUESTIONNAIRES_C_HBI_FAILURE = '[Doctor] Get questionnaires Clinical HBI for Patient Failure',
  GET_QUESTIONNAIRES_C_PRISM = '[Doctor] Get questionnaires Clinical PRISM for Patient',
  GET_QUESTIONNAIRES_C_PRISM_SUCCESS = '[Doctor] Get questionnaires Clinical PRISM for Patient Success',
  GET_QUESTIONNAIRES_C_PRISM_FAILURE = '[Doctor] Get questionnaires Clinical PRISM for Patient Failure',
  GET_QUESTIONNAIRES_EORTC = '[Doctor] Get questionnaires EORTC for Patient',
  GET_QUESTIONNAIRES_EORTC_SUCCESS = '[Doctor] Get questionnaires EORTC for Patient Success',
  GET_QUESTIONNAIRES_EORTC_FAILURE = '[Doctor] Get questionnaires EORTC for Patient Failure',
  GET_QUESTIONNAIRES_EQ5D5L = '[Doctor] Get questionnaires EQ5D5L for Patient',
  GET_QUESTIONNAIRES_EQ5D5L_SUCCESS = '[Doctor] Get questionnaires EQ5D5L for Patient Success',
  GET_QUESTIONNAIRES_EQ5D5L_FAILURE = '[Doctor] Get questionnaires EQ5D5L for Patient Failure',
  GET_QUESTIONNAIRES_HADS = '[Doctor] Get questionnaires HADS for Patient',
  GET_QUESTIONNAIRES_HADS_SUCCESS = '[Doctor] Get questionnaires HADS for Patient Success',
  GET_QUESTIONNAIRES_HADS_FAILURE = '[Doctor] Get questionnaires HADS for Patient Failure',
  GET_QUESTIONNAIRES_HBI = '[Doctor] Get questionnaires HBI for Patient',
  GET_QUESTIONNAIRES_HBI_SUCCESS = '[Doctor] Get questionnaires HBI for Patient Success',
  GET_QUESTIONNAIRES_HBI_FAILURE = '[Doctor] Get questionnaires HBI for Patient Failure',
  GET_QUESTIONNAIRES_IBDDISK = '[Doctor] Get questionnaires IBDDISK for Patient',
  GET_QUESTIONNAIRES_IBDDISK_SUCCESS = '[Doctor] Get questionnaires IBDDISK for Patient Success',
  GET_QUESTIONNAIRES_IBDDISK_FAILURE = '[Doctor] Get questionnaires IBDDISK for Patient Failure',
  GET_QUESTIONNAIRES_IBDQ = '[Doctor] Get questionnaires IBDQ for Patient',
  GET_QUESTIONNAIRES_IBDQ_SUCCESS = '[Doctor] Get questionnaires IBDQ for Patient Success',
  GET_QUESTIONNAIRES_IBDQ_FAILURE = '[Doctor] Get questionnaires IBDQ for Patient Failure',
  GET_QUESTIONNAIRES_LARS = '[Doctor] Get questionnaires LARS for Patient',
  GET_QUESTIONNAIRES_LARS_SUCCESS = '[Doctor] Get questionnaires LARS for Patient Success',
  GET_QUESTIONNAIRES_LARS_FAILURE = '[Doctor] Get questionnaires LARS for Patient Failure',
  GET_QUESTIONNAIRES_IPAQSF = '[Doctor] Get questionnaires IPAQSF for Patient',
  GET_QUESTIONNAIRES_IPAQSF_SUCCESS = '[Doctor] Get questionnaires IPAQSF for Patient Success',
  GET_QUESTIONNAIRES_IPAQSF_FAILURE = '[Doctor] Get questionnaires IPAQSF for Patient Failure',
  GET_QUESTIONNAIRES_MIAH_CD = '[Doctor] Get questionnaires MIAH_CD for Patient',
  GET_QUESTIONNAIRES_MIAH_CD_SUCCESS = '[Doctor] Get questionnaires MIAH_CD for Patient Success',
  GET_QUESTIONNAIRES_MIAH_CD_FAILURE = '[Doctor] Get questionnaires MIAH_CD for Patient Failure',
  GET_QUESTIONNAIRES_MIAH_UC = '[Doctor] Get questionnaires MIAH_UC for Patient',
  GET_QUESTIONNAIRES_MIAH_UC_SUCCESS = '[Doctor] Get questionnaires MIAH_UC for Patient Success',
  GET_QUESTIONNAIRES_MIAH_UC_FAILURE = '[Doctor] Get questionnaires MIAH_UC for Patient Failure',
  GET_QUESTIONNAIRES_MMAS8 = '[Doctor] Get questionnaires MMAS8 for Patient',
  GET_QUESTIONNAIRES_MMAS8_SUCCESS = '[Doctor] Get questionnaires MMAS8 for Patient Success',
  GET_QUESTIONNAIRES_MMAS8_FAILURE = '[Doctor] Get questionnaires MMAS8 for Patient Failure',
  GET_QUESTIONNAIRES_P_SCCAI = '[Doctor] Get questionnaires Patient SCCAI for Patient',
  GET_QUESTIONNAIRES_P_SCCAI_SUCCESS = '[Doctor] Get questionnaires Patient SCCAI for Patient Success',
  GET_QUESTIONNAIRES_P_SCCAI_FAILURE = '[Doctor] Get questionnaires Patient SCCAI for Patient Failure',
  GET_QUESTIONNAIRES_PHQ9 = '[Doctor] Get questionnaires PHQ9 for Patient',
  GET_QUESTIONNAIRES_PHQ9_SUCCESS = '[Doctor] Get questionnaires PHQ9 for Patient Success',
  GET_QUESTIONNAIRES_PHQ9_FAILURE = '[Doctor] Get questionnaires PHQ9 for Patient Failure',
  GET_QUESTIONNAIRES_PRISM = '[Doctor] Get questionnaires PRISM for Patient',
  GET_QUESTIONNAIRES_PRISM_SUCCESS = '[Doctor] Get questionnaires PRISM for Patient Success',
  GET_QUESTIONNAIRES_PRISM_FAILURE = '[Doctor] Get questionnaires PRISM for Patient Failure',
  GET_QUESTIONNAIRES_PSQI = '[Doctor] Get questionnaires PSQI for Patient',
  GET_QUESTIONNAIRES_PSQI_SUCCESS = '[Doctor] Get questionnaires PSQI for Patient Success',
  GET_QUESTIONNAIRES_PSQI_FAILURE = '[Doctor] Get questionnaires PSQI for Patient Failure',
  GET_QUESTIONNAIRES_SIBDQ = '[Doctor] Get questionnaires SIBDQ for Patient',
  GET_QUESTIONNAIRES_SIBDQ_SUCCESS = '[Doctor] Get questionnaires SIBDQ for Patient Success',
  GET_QUESTIONNAIRES_SIBDQ_FAILURE = '[Doctor] Get questionnaires SIBDQ for Patient Failure',
  GET_QUESTIONNAIRES_TSQM = '[Doctor] Get questionnaires TSQM for Patient',
  GET_QUESTIONNAIRES_TSQM_SUCCESS = '[Doctor] Get questionnaires TSQM for Patient Success',
  GET_QUESTIONNAIRES_TSQM_FAILURE = '[Doctor] Get questionnaires TSQM for Patient Failure',
  GET_QUESTIONNAIRES_WPAI = '[Doctor] Get questionnaires WPAI for Patient',
  GET_QUESTIONNAIRES_WPAI_SUCCESS = '[Doctor] Get questionnaires WPAI for Patient Success',
  GET_QUESTIONNAIRES_WPAI_FAILURE = '[Doctor] Get questionnaires WPAI for Patient Failure',
  GET_JOBS = '[Doctor] Get jobs for patient',
  GET_JOBS_SUCCESS = '[Doctor] Get jobs for patient Success',
  GET_JOBS_FAILURE = '[Doctor] Get jobs for patient Failure',
  GET_QUESTIONNAIRES_DATA_CONSENT = '[Doctor] Get questionnaires Data Consent for Patient',
  GET_QUESTIONNAIRES_DATA_CONSENT_SUCCESS = '[Doctor] Get questionnaires Data Consent for Patient Success',
  GET_QUESTIONNAIRES_DATA_CONSENT_FAILURE = '[Doctor] Get questionnaires Data Consent for Patient Failure',
}

export class GetPatients implements Action {
  readonly type = DoctorActionTypes.GET_PATIENTS;
}

export class GetPatientsSuccess implements Action {
  readonly type = DoctorActionTypes.GET_PATIENTS_SUCCESS;
  constructor(public payload: any) { }
}

export class GetPatientsFailure implements Action {
  readonly type = DoctorActionTypes.GET_PATIENTS_FAILURE;
  constructor(public payload: any) { }
}

export class GetGlobalPatients implements Action {
  readonly type = DoctorActionTypes.GET_GLOBAL_PATIENTS;
}

export class GetGlobalPatientsSuccess implements Action {
  readonly type = DoctorActionTypes.GET_GLOBAL_PATIENTS_SUCCESS;
  constructor(public payload: any) { }
}

export class GetGlobalPatientsFailure implements Action {
  readonly type = DoctorActionTypes.GET_GLOBAL_PATIENTS_FAILURE;
  constructor(public payload: any) { }
}

// TODO: modify when new questionnaires added

export class GetQuestionnairesClinicalSCCAI implements Action {
  readonly type = DoctorActionTypes.GET_QUESTIONNAIRES_C_SCCAI;
  constructor(public payload: any) { }
}

export class GetQuestionnairesClinicalSCCAISuccess implements Action {
  readonly type = DoctorActionTypes.GET_QUESTIONNAIRES_C_SCCAI_SUCCESS;
  constructor(public payload: any) { }
}

export class GetQuestionnairesClinicalSCCAIFailure implements Action {
  readonly type = DoctorActionTypes.GET_QUESTIONNAIRES_C_SCCAI_FAILURE;
  constructor(public payload: any) { }
}

export class GetQuestionnairesClinicalHBI implements Action {
  readonly type = DoctorActionTypes.GET_QUESTIONNAIRES_C_HBI;
  constructor(public payload: any) { }
}

export class GetQuestionnairesClinicalHBISuccess implements Action {
  readonly type = DoctorActionTypes.GET_QUESTIONNAIRES_C_HBI_SUCCESS;
  constructor(public payload: any) { }
}

export class GetQuestionnairesClinicalHBIFailure implements Action {
  readonly type = DoctorActionTypes.GET_QUESTIONNAIRES_C_HBI_FAILURE;
  constructor(public payload: any) { }
}

export class GetQuestionnairesClinicalPRISM implements Action {
  readonly type = DoctorActionTypes.GET_QUESTIONNAIRES_C_PRISM;
  constructor(public payload: any) { }
}

export class GetQuestionnairesClinicalPRISMSuccess implements Action {
  readonly type = DoctorActionTypes.GET_QUESTIONNAIRES_C_PRISM_SUCCESS;
  constructor(public payload: any) { }
}

export class GetQuestionnairesClinicalPRISMFailure implements Action {
  readonly type = DoctorActionTypes.GET_QUESTIONNAIRES_C_PRISM_FAILURE;
  constructor(public payload: any) { }
}

export class GetQuestionnairesEORTC implements Action {
  readonly type = DoctorActionTypes.GET_QUESTIONNAIRES_EORTC;
  constructor(public payload: any) { }
}

export class GetQuestionnairesEORTCSuccess implements Action {
  readonly type = DoctorActionTypes.GET_QUESTIONNAIRES_EORTC_SUCCESS;
  constructor(public payload: any) { }
}

export class GetQuestionnairesEORTCFailure implements Action {
  readonly type = DoctorActionTypes.GET_QUESTIONNAIRES_EORTC_FAILURE;
  constructor(public payload: any) { }
}

export class GetQuestionnairesEQ5D5L implements Action {
  readonly type = DoctorActionTypes.GET_QUESTIONNAIRES_EQ5D5L;
  constructor(public payload: any) { }
}

export class GetQuestionnairesEQ5D5LSuccess implements Action {
  readonly type = DoctorActionTypes.GET_QUESTIONNAIRES_EQ5D5L_SUCCESS;
  constructor(public payload: any) { }
}

export class GetQuestionnairesEQ5D5LFailure implements Action {
  readonly type = DoctorActionTypes.GET_QUESTIONNAIRES_EQ5D5L_FAILURE;
  constructor(public payload: any) { }
}

export class GetQuestionnairesHADS implements Action {
  readonly type = DoctorActionTypes.GET_QUESTIONNAIRES_HADS;
  constructor(public payload: any) { }
}

export class GetQuestionnairesHADSSuccess implements Action {
  readonly type = DoctorActionTypes.GET_QUESTIONNAIRES_HADS_SUCCESS;
  constructor(public payload: any) { }
}

export class GetQuestionnairesHADSFailure implements Action {
  readonly type = DoctorActionTypes.GET_QUESTIONNAIRES_HADS_FAILURE;
  constructor(public payload: any) { }
}

export class GetQuestionnairesHBI implements Action {
  readonly type = DoctorActionTypes.GET_QUESTIONNAIRES_HBI;
  constructor(public payload: any) { }
}

export class GetQuestionnairesHBISuccess implements Action {
  readonly type = DoctorActionTypes.GET_QUESTIONNAIRES_HBI_SUCCESS;
  constructor(public payload: any) { }
}

export class GetQuestionnairesHBIFailure implements Action {
  readonly type = DoctorActionTypes.GET_QUESTIONNAIRES_HBI_FAILURE;
  constructor(public payload: any) { }
}

export class GetQuestionnairesIBDDisk implements Action {
  readonly type = DoctorActionTypes.GET_QUESTIONNAIRES_IBDDISK;
  constructor(public payload: any) { }
}

export class GetQuestionnairesIBDDiskSuccess implements Action {
  readonly type = DoctorActionTypes.GET_QUESTIONNAIRES_IBDDISK_SUCCESS;
  constructor(public payload: any) { }
}

export class GetQuestionnairesIBDDiskFailure implements Action {
  readonly type = DoctorActionTypes.GET_QUESTIONNAIRES_IBDDISK_FAILURE;
  constructor(public payload: any) { }
}

export class GetQuestionnairesIBDQ implements Action {
  readonly type = DoctorActionTypes.GET_QUESTIONNAIRES_IBDQ;
  constructor(public payload: any) { }
}

export class GetQuestionnairesIBDQSuccess implements Action {
  readonly type = DoctorActionTypes.GET_QUESTIONNAIRES_IBDQ_SUCCESS;
  constructor(public payload: any) { }
}

export class GetQuestionnairesIBDQFailure implements Action {
  readonly type = DoctorActionTypes.GET_QUESTIONNAIRES_IBDQ_FAILURE;
  constructor(public payload: any) { }
}

export class GetQuestionnairesLARS implements Action {
  readonly type = DoctorActionTypes.GET_QUESTIONNAIRES_LARS;
  constructor(public payload: any) { }
}
export class GetQuestionnairesLARSSuccess implements Action {
  readonly type = DoctorActionTypes.GET_QUESTIONNAIRES_LARS_SUCCESS;
  constructor(public payload: any) { }
}

export class GetQuestionnairesLARSFailure implements Action {
  readonly type = DoctorActionTypes.GET_QUESTIONNAIRES_LARS_FAILURE;
  constructor(public payload: any) { }
}

export class GetQuestionnairesIPAQSF implements Action {
  readonly type = DoctorActionTypes.GET_QUESTIONNAIRES_IPAQSF;
  constructor(public payload: any) { }
}

export class GetQuestionnairesIPAQSFSuccess implements Action {
  readonly type = DoctorActionTypes.GET_QUESTIONNAIRES_IPAQSF_SUCCESS;
  constructor(public payload: any) { }
}

export class GetQuestionnairesIPAQSFFailure implements Action {
  readonly type = DoctorActionTypes.GET_QUESTIONNAIRES_IPAQSF_FAILURE;
  constructor(public payload: any) { }
}

export class GetQuestionnairesMIAHCD implements Action {
  readonly type = DoctorActionTypes.GET_QUESTIONNAIRES_MIAH_CD;
  constructor(public payload: any) { }
}

export class GetQuestionnairesMIAHCDSuccess implements Action {
  readonly type = DoctorActionTypes.GET_QUESTIONNAIRES_MIAH_CD_SUCCESS;
  constructor(public payload: any) { }
}

export class GetQuestionnairesMIAHCDFailure implements Action {
  readonly type = DoctorActionTypes.GET_QUESTIONNAIRES_MIAH_CD_FAILURE;
  constructor(public payload: any) { }
}

export class GetQuestionnairesMIAHUC implements Action {
  readonly type = DoctorActionTypes.GET_QUESTIONNAIRES_MIAH_UC;
  constructor(public payload: any) { }
}

export class GetQuestionnairesMIAHUCSuccess implements Action {
  readonly type = DoctorActionTypes.GET_QUESTIONNAIRES_MIAH_UC_SUCCESS;
  constructor(public payload: any) { }
}

export class GetQuestionnairesMIAHUCFailure implements Action {
  readonly type = DoctorActionTypes.GET_QUESTIONNAIRES_MIAH_UC_FAILURE;
  constructor(public payload: any) { }
}

export class GetQuestionnairesMMAS8 implements Action {
  readonly type = DoctorActionTypes.GET_QUESTIONNAIRES_MMAS8;
  constructor(public payload: any) { }
}

export class GetQuestionnairesMMAS8Success implements Action {
  readonly type = DoctorActionTypes.GET_QUESTIONNAIRES_MMAS8_SUCCESS;
  constructor(public payload: any) { }
}

export class GetQuestionnairesMMAS8Failure implements Action {
  readonly type = DoctorActionTypes.GET_QUESTIONNAIRES_MMAS8_FAILURE;
  constructor(public payload: any) { }
}

export class GetQuestionnairesPatientSCCAI implements Action {
  readonly type = DoctorActionTypes.GET_QUESTIONNAIRES_P_SCCAI;
  constructor(public payload: any) { }
}

export class GetQuestionnairesPatientSCCAISuccess implements Action {
  readonly type = DoctorActionTypes.GET_QUESTIONNAIRES_P_SCCAI_SUCCESS;
  constructor(public payload: any) { }
}

export class GetQuestionnairesPatientSCCAIFailure implements Action {
  readonly type = DoctorActionTypes.GET_QUESTIONNAIRES_P_SCCAI_FAILURE;
  constructor(public payload: any) { }
}

export class GetQuestionnairesPHQ9 implements Action {
  readonly type = DoctorActionTypes.GET_QUESTIONNAIRES_PHQ9;
  constructor(public payload: any) { }
}

export class GetQuestionnairesPHQ9Success implements Action {
  readonly type = DoctorActionTypes.GET_QUESTIONNAIRES_PHQ9_SUCCESS;
  constructor(public payload: any) { }
}

export class GetQuestionnairesPHQ9Failure implements Action {
  readonly type = DoctorActionTypes.GET_QUESTIONNAIRES_PHQ9_FAILURE;
  constructor(public payload: any) { }
}

export class GetQuestionnairesPRISM implements Action {
  readonly type = DoctorActionTypes.GET_QUESTIONNAIRES_PRISM;
  constructor(public payload: any) { }
}

export class GetQuestionnairesPRISMSuccess implements Action {
  readonly type = DoctorActionTypes.GET_QUESTIONNAIRES_PRISM_SUCCESS;
  constructor(public payload: any) { }
}

export class GetQuestionnairesPRISMFailure implements Action {
  readonly type = DoctorActionTypes.GET_QUESTIONNAIRES_PRISM_FAILURE;
  constructor(public payload: any) { }
}

export class GetQuestionnairesPSQI implements Action {
  readonly type = DoctorActionTypes.GET_QUESTIONNAIRES_PSQI;
  constructor(public payload: any) { }
}

export class GetQuestionnairesPSQISuccess implements Action {
  readonly type = DoctorActionTypes.GET_QUESTIONNAIRES_PSQI_SUCCESS;
  constructor(public payload: any) { }
}

export class GetQuestionnairesPSQIFailure implements Action {
  readonly type = DoctorActionTypes.GET_QUESTIONNAIRES_PSQI_FAILURE;
  constructor(public payload: any) { }
}


export class GetQuestionnairesSIBDQ implements Action {
  readonly type = DoctorActionTypes.GET_QUESTIONNAIRES_SIBDQ;
  constructor(public payload: any) { }
}

export class GetQuestionnairesSIBDQSuccess implements Action {
  readonly type = DoctorActionTypes.GET_QUESTIONNAIRES_SIBDQ_SUCCESS;
  constructor(public payload: any) { }
}

export class GetQuestionnairesSIBDQFailure implements Action {
  readonly type = DoctorActionTypes.GET_QUESTIONNAIRES_SIBDQ_FAILURE;
  constructor(public payload: any) { }
}

export class GetQuestionnairesTSQM implements Action {
  readonly type = DoctorActionTypes.GET_QUESTIONNAIRES_TSQM;
  constructor(public payload: any) { }
}

export class GetQuestionnairesTSQMSuccess implements Action {
  readonly type = DoctorActionTypes.GET_QUESTIONNAIRES_TSQM_SUCCESS;
  constructor(public payload: any) { }
}

export class GetQuestionnairesTSQMFailure implements Action {
  readonly type = DoctorActionTypes.GET_QUESTIONNAIRES_TSQM_FAILURE;
  constructor(public payload: any) { }
}

export class GetQuestionnairesWPAI implements Action {
  readonly type = DoctorActionTypes.GET_QUESTIONNAIRES_WPAI;
  constructor(public payload: any) { }
}

export class GetQuestionnairesWPAISuccess implements Action {
  readonly type = DoctorActionTypes.GET_QUESTIONNAIRES_WPAI_SUCCESS;
  constructor(public payload: any) { }
}

export class GetQuestionnairesWPAIFailure implements Action {
  readonly type = DoctorActionTypes.GET_QUESTIONNAIRES_WPAI_FAILURE;
  constructor(public payload: any) { }
}

export class GetJobs implements Action {
  readonly type = DoctorActionTypes.GET_JOBS;
  constructor(public payload: any) { }
}

export class GetJobsSuccess implements Action {
  readonly type = DoctorActionTypes.GET_JOBS_SUCCESS;
  constructor(public payload: any) { }
}

export class GetJobsFailure implements Action {
  readonly type = DoctorActionTypes.GET_JOBS_FAILURE;
  constructor(public payload: any) { }
}

export class GetQuestionnairesDataConsent implements Action {
  readonly type = DoctorActionTypes.GET_QUESTIONNAIRES_DATA_CONSENT;
  constructor(public payload: any) { }
}

export class GetQuestionnairesDataConsentSuccess implements Action {
  readonly type = DoctorActionTypes.GET_QUESTIONNAIRES_DATA_CONSENT_SUCCESS;
  constructor(public payload: any) { }
}

export class GetQuestionnairesDataConsentFailure implements Action {
  readonly type = DoctorActionTypes.GET_QUESTIONNAIRES_DATA_CONSENT_FAILURE;
  constructor(public payload: any) { }
}

export type AllDoctorActions =
  | GetPatients
  | GetPatientsSuccess
  | GetPatientsFailure
  | GetQuestionnairesIBDDisk
  | GetQuestionnairesIBDDiskSuccess
  | GetQuestionnairesIBDDiskFailure
  | GetQuestionnairesIBDQ
  | GetQuestionnairesIBDQSuccess
  | GetQuestionnairesIBDQFailure
  | GetQuestionnairesLARS
  | GetQuestionnairesLARSSuccess
  | GetQuestionnairesLARSFailure
  | GetQuestionnairesEORTC
  | GetQuestionnairesEORTCSuccess
  | GetQuestionnairesEORTCFailure
  | GetQuestionnairesEQ5D5L
  | GetQuestionnairesEQ5D5LSuccess
  | GetQuestionnairesEQ5D5LFailure
  | GetQuestionnairesHBI
  | GetQuestionnairesHBISuccess
  | GetQuestionnairesHBIFailure
  | GetQuestionnairesSIBDQ
  | GetQuestionnairesSIBDQSuccess
  | GetQuestionnairesSIBDQFailure
  | GetQuestionnairesTSQM
  | GetQuestionnairesTSQMSuccess
  | GetQuestionnairesTSQMFailure
  | GetQuestionnairesWPAI
  | GetQuestionnairesWPAISuccess
  | GetQuestionnairesWPAIFailure
  | GetJobs
  | GetJobsSuccess
  | GetJobsFailure
  | GetQuestionnairesDataConsent
  | GetQuestionnairesDataConsentSuccess
  | GetQuestionnairesDataConsentFailure;
